import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import isFunction from 'lodash/isFunction'

import * as actions from './slice'

export const useActionRunner = (action, options = {}) => {
  const {
    initialFetchingState = false,
    errorNotification,
    successNotification,
  } = options

  const [running, setRunning] = useState(initialFetchingState)
  const { showError, showSuccess } = useNotification()

  const actionsArray = Array.isArray(action) ? action : [action]

  const runActions = async (...args) => {
    setRunning(true)
    const result = await Promise.all(
      actionsArray.map(action => action(...args))
    )
    setRunning(false)

    const errors = result.filter(a => a.error)

    if (errors.length) {
      if (isFunction(errorNotification)) {
        const arg = Array.isArray(action) ? actions : errors[0]
        const notificationText = errorNotification(arg)
        showError(notificationText)
      } else {
        showError(errorNotification)
      }
      console.error('Error notification errors: ', errors)
    } else if (successNotification) {
      showSuccess(successNotification)
    }

    if (Array.isArray(action)) {
      return result
    } else {
      return result[0]
    }
  }

  return [runActions, running]
}

export const useNotification = () => {
  const dispatch = useDispatch()

  return {
    ...bindActionCreators(actions, dispatch),
    ...useSelector(state => state.notification),
  }
}
